export const config = {
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
    version: import.meta.env.VITE_API_VERSION || 'v1',
    timeout: parseInt(import.meta.env.VITE_API_TIMEOUT || '30000'),
  },
  websocket: {
    url: import.meta.env.VITE_WEBSOCKET_URL || 'ws://localhost:3000/cable',
  },
  app: {
    name: import.meta.env.VITE_APP_NAME || 'YochienAI Admin Portal',
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
    environment: import.meta.env.VITE_APP_ENVIRONMENT || 'development',
  },
  auth: {
    tokenStorageKey: import.meta.env.VITE_AUTH_TOKEN_STORAGE_KEY || 'yochien_auth_tokens',
    userStorageKey: import.meta.env.VITE_AUTH_USER_STORAGE_KEY || 'yochien_user',
    refreshThreshold: parseInt(import.meta.env.VITE_AUTH_REFRESH_THRESHOLD || '300000'),
  },
  features: {
    darkMode: import.meta.env.VITE_FEATURE_DARK_MODE === 'true',
    notifications: import.meta.env.VITE_FEATURE_NOTIFICATIONS === 'true',
    analytics: import.meta.env.VITE_FEATURE_ANALYTICS === 'true',
    realTime: import.meta.env.VITE_FEATURE_REAL_TIME === 'true',
  },
  debug: {
    enabled: import.meta.env.VITE_DEBUG_MODE === 'true',
    mockApi: import.meta.env.VITE_MOCK_API === 'true',
    logLevel: import.meta.env.VITE_LOG_LEVEL || 'info',
  },
} as const;

export const getApiUrl = (endpoint: string) => {
  const base = config.api.baseUrl;
  const version = config.api.version;
  return `${base}/api/${version}${endpoint}`;
};